import { Component, OnInit } from "@angular/core";
import { SubscriptionService } from "../../providers/subscription.service";
import { ProfileService } from "../../providers/profile.service";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
@Component({
    selector: "app-credit-card",
    templateUrl: "./credit-card.component.html",
    styleUrls: ["./credit-card.component.scss"],
    imports: [NgClass, TranslateModule]
})
export class CreditCardComponent implements OnInit {
  constructor(
    public subServ: SubscriptionService,
    public profServ: ProfileService
  ) {}

  ngOnInit() {}
}
